import React, { useEffect, useState } from "react";
import { getDirectusClient } from "../../../lib/directus";
import { Button, Form, Input, Modal, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import { readItems } from "@directus/sdk";
import { useSelector } from "react-redux";

function Caja(props) {
  const arrayp = props.productosagregados;
  const [seriales, setSeriales] = useState([]);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const userRoleID = useSelector((state) => state.userdata.role.name);
  const [productos, setProductos] = useState([]);
  const [form] = useForm();

  const onFinish = async (values) => {
    const directus = await getDirectusClient();

    await directus
      .request(
        readItems("seriales", {
          fields: [
            "*",
            "producto.*",
            "producto.grupo.impuesto",
          ],
          filter: { 
            caja: values.caja, 
            estado: 1,
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                }
              : {}),
          },
          limit: -1,
        })
      )
      .then((res) => {
        if (res.length <= 0) {
          Modal.error({
            title:
              "No se encontraron seriales activos con los datos suministrados",
          });
        }
        setSeriales(res);
        console.log("ddd");
        console.log(res);
        let existen = 0;
        props.setProductosagregados(res);
      })
      .catch((err) => console.log(err));

    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {}, [arrayp]);

  return (
    <>
      {props.productosagregados.length}
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Space size="large" direction="vertical" style={{ display: "flex" }}>
          <Form.Item
            wrapperCol={{ offset: 8, span: 16 }}
            label="Caja"
            name="caja"
            rules={[{ required: true, message: "Please input your caja!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button type="primary" htmlType="submit">
              procesar
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </>
  );
}

export default Caja;
